import React from 'react';
import { Select, Typography } from 'antd';

const { Text } = Typography;

interface PillSelectFieldProps {
  label: string;
  options: { value: string | number; label: string }[];
  placeholder?: string;
  disabled?: boolean;
  value?: string | number;
  onChange?: (value: string | number) => void;
}

/**
 * Small fixed label + pill select, for a fixed-options field outside the
 * publish wizard (see HeavyDutyMachineryForm's own local copy of this, kept
 * separate on purpose so this one can evolve independently of that page) --
 * same "caption above, never overlaps the value" shape as PillNumberField,
 * for a Select-backed field instead of a typed number.
 */
const PillSelectField: React.FC<PillSelectFieldProps> = ({ label, value, onChange, options, placeholder, disabled }) => (
  <div>
    <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 6 }}>
      {label}
    </Text>
    <Select
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      style={{ width: '100%' }}
      value={value}
      onChange={onChange}
    />
  </div>
);

export default PillSelectField;
